import { atom } from "recoil"

export const couponInputAtom = atom({
  key: "couponInput",
  default: "",
})
